// видеоплеер
$(document).ready(function () {
  if ($(".video-player").length > 0) {
    $(".video-player").each(function () {
      let playButton = document.createElement("div");
      playButton.classList.add("play-button");

      let playButtonIcon = document.createElement("div");
      playButtonIcon.classList.add("play-button__icon");
      playButton.appendChild(playButtonIcon);

      let video = document.createElement("video");
      video.src = $(this).data("src");
      video.autoplay = false;
      video.controls = false;
      video.muted = false;
      video.type = "video/mp4";

      playButton.addEventListener("click", function () {
        if (video.paused == true) {
          video.play();
        } else {
          video.pause();
        }
      });

      video.addEventListener("pause", (event) => {
        playButton.classList.remove("hidden");
        video.controls = false;
      });

      video.addEventListener("play", (event) => {
        playButton.classList.add("hidden");
        $(".video-player video").each(function () {
          if ($(this)[0] !== video) $(this)[0].pause();
        });
        video.controls = true;
      });

      $(this)[0].appendChild(video);
      $(this)[0].appendChild(playButton);
    });
  }
});
// ! видеоплеер
